query ContentTypesHeaderQuery($contentId: ID) {
  content(id: $contentId) {
    nodes {
      title
      contentProperties {
        latest {
          hasBeenTitled
        }
      }
    }
  }
}
